var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "307.09 306.91 20.08 20.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M327.13,316.95c0,5.54-4.47,9.99-10.04,9.99-5.47,0-9.97-4.5-9.96-9.97,0-5.58,4.45-10.03,10.03-10.03,5.53,0,9.97,4.47,9.97,10.02ZM316.52,316.56s-.05.03-.08.05c-.06-.08-.11-.17-.18-.24-.56-.57-1.13-1.13-1.69-1.7-.33-.33-.75-.34-1.04-.04-.28.29-.26.7.06,1.02,1.02,1.03,2.05,2.05,3.07,3.08.32.32.72.33,1.04.01,1.04-1.03,2.08-2.07,3.1-3.11.11-.11.19-.28.22-.43.06-.29-.1-.57-.37-.7-.28-.14-.57-.1-.8.13-.6.59-1.19,1.19-1.79,1.78-.06.06-.12.11-.22.21,0-.72,0-1.38,0-2.03,0-1.32,0-2.63,0-3.95,0-.29-.1-.52-.37-.66-.46-.23-.95.1-.95.64,0,1.83,0,3.66,0,5.5,0,.15,0,.3,0,.44ZM317.18,321.67c1.11,0,2.21,0,3.32,0,.12,0,.25,0,.37-.05.32-.11.51-.45.44-.78-.07-.35-.34-.58-.71-.58-1.29,0-2.58,0-3.87,0-.98,0-1.96,0-2.95,0-.31,0-.55.13-.68.41-.22.47.12.99.66.99,1.14,0,2.28,0,3.42,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCircle);
export default __webpack_public_path__ + "static/media/download-circle.187590bd66f9fc6d403b9f8bb7294429.svg";
export { ForwardRef as ReactComponent };